import { render, staticRenderFns } from "./elementDialog.vue?vue&type=template&id=8420194e&scoped=true&lang=pug"
import script from "./elementDialog.vue?vue&type=script&lang=js"
export * from "./elementDialog.vue?vue&type=script&lang=js"
import style0 from "./elementDialog.vue?vue&type=style&index=0&id=8420194e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8420194e",
  null
  
)

export default component.exports